import axios, { AxiosRequestConfig } from 'axios';

import {
	hasValue,
	type HttpConfig,
	type HttpResponse,
	type HttpService
} from '@contexts/shared/domain';

export function axiosHttpServiceBuilder(globalConfig: HttpConfig): HttpService {
	const buildRequestConfig = (
		config: HttpConfig,
		globalConfig: HttpConfig,
		params?: Record<string, string>
	): AxiosRequestConfig => {
		let requestConfig: AxiosRequestConfig = {};

		const header = config?.headers ?? globalConfig.headers;
		if (hasValue(header)) {
			requestConfig.headers = header;
		}

		if (hasValue(params)) {
			requestConfig.params = params;
		}

		const withCredentials = config?.withCredentials ?? globalConfig.withCredentials;
		if (hasValue(withCredentials)) {
			requestConfig.withCredentials = withCredentials;
		}

		const responseType = config?.responseType ?? globalConfig.responseType;
		if (hasValue(responseType)) {
			requestConfig.responseType = responseType;
		}

		const validateStatus = config?.validateStatus ?? globalConfig.validateStatus;
		if (hasValue(validateStatus)) {
			requestConfig.validateStatus = validateStatus;
		}

		return requestConfig;
	};

	return {
		async get<ItemType>(
			url: string,
			params?: Record<string, string>,
			config?: HttpConfig
		): Promise<HttpResponse<ItemType>> {
			return axios.get<ItemType>(url, buildRequestConfig(config, globalConfig, params));
		},
		async post<ItemType>(
			url: string,
			data: unknown,
			config?: HttpConfig
		): Promise<HttpResponse<ItemType>> {
			return axios.post(url, data, buildRequestConfig(config, globalConfig));
		},
		async put<ItemType>(
			url: string,
			data: Record<string, unknown>,
			config?: HttpConfig
		): Promise<HttpResponse<ItemType>> {
			return axios.put(url, data, buildRequestConfig(config, globalConfig));
		},
		async patch<ItemType>(
			url: string,
			data?: Record<string, unknown>,
			config?: HttpConfig
		): Promise<HttpResponse<ItemType>> {
			return axios.patch(url, data, buildRequestConfig(config, globalConfig));
		},
		async delete<ItemType>(
			url: string,
			params?: Record<string, string>,
			config?: HttpConfig
		): Promise<HttpResponse<ItemType>> {
			return axios.delete(url, buildRequestConfig(config, globalConfig, params));
		}
	};
}
